import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { adminApi } from "../../lib/api";

export const PhotoThumb = ({ fileId, testId, size = "h-12 w-10" }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!fileId) return undefined;
    let u;
    adminApi.get(`/admin/files/${fileId}`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [fileId]);
  return (
    <span data-testid={testId} className={`flex ${size} shrink-0 items-center justify-center overflow-hidden border border-white/10 bg-[#0B1120]`}>
      {url ? <img src={url} alt="Passport" className="h-full w-full object-cover" /> : <UserRound className="h-5 w-5 text-slate-600" />}
    </span>
  );
};
